import { useCallback, useState } from "react";

import { ButtonProps, Flex, Tooltip } from "@radix-ui/themes";

import { IconButton } from "../IconButton";

type CopyButtonProps = {
  value?: string;
  label?: string;
} & ButtonProps;

export const CopyButton = ({
  value,
  label,
  ...buttonProps
}: CopyButtonProps) => {
  const [copied, setCopied] = useState(false);
  const copy = useCallback(() => {
    navigator.clipboard.writeText(value || "").then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1000);
    });
  }, [value]);
  return (
    <Tooltip
      content={copied ? "Copied!" : label ?? "Copy to clipboard"}
      open={copied || undefined}
    >
      <Flex asChild align="center" pt="2">
        <IconButton
          onClick={() => {
            setCopied(true);
            copy();
          }}
          variant="ghost"
          color="gray"
          style={{
            background: "none",
            cursor: "pointer",
          }}
          {...buttonProps}
        >
          <div
            style={{
              position: "relative",
              height: 18,
              width: 18,
            }}
          >
            <Clippy
              style={{
                color: "gray",
                position: "absolute",
                top: 0,
                left: 0,
                strokeDasharray: 50,
                strokeDashoffset: copied ? -50 : 0,
                transition: "all 300ms ease-in-out",
              }}
            />
            <Check
              visibility={copied ? "visible" : "hidden"}
              style={{
                color: "green",
                position: "absolute",
                top: 0,
                left: 0,
                strokeDasharray: 50,
                strokeDashoffset: copied ? 0 : -50,
                transition: "all 300ms ease-in-out",
              }}
            />
          </div>
        </IconButton>
      </Flex>
    </Tooltip>
  );
};

function Clippy(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      stroke="currentColor"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M5.75 4.75H10.25V1.75H5.75V4.75Z" />
      <path d="M3.25 2.88379C2.9511 3.05669 2.75 3.37987 2.75 3.75001V13.25C2.75 13.8023 3.19772 14.25 3.75 14.25H12.25C12.8023 14.25 13.25 13.8023 13.25 13.25V3.75001C13.25 3.37987 13.0489 3.05669 12.75 2.88379" />
    </svg>
  );
}

function Check(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      stroke="currentColor"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M13.25 4.75L6 12L2.75 8.75" />
    </svg>
  );
}
